import { GetServerSidePropsContext } from "next";
import { SWRConfig } from "swr";

import Bugsnag from "@bugsnag/js";

import EntityPageContainer from "components/EntityPageLayout";
import { entityLayoutData } from "components/EntityPageLayout/entityLayoutData";
import EntityPageNews from "components/EntityPageLayout/EntityPageNews";
import {
  datacloudNewsUrl,
  entityNewsUrl,
} from "components/EntityPageLayout/EntityPageNews/EntityPageNewsList";
import type { NextPageWithLayout } from "pages/_app";
import { baseFetcher } from "utils/baseFetcher";
import { isSsr } from "utils/isSsr";

const EntityNewsTabPage: NextPageWithLayout = () => {
  return <EntityPageNews />;
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  try {
    const slug = context.params?.slug as string;

    const datacloudUrl = datacloudNewsUrl(slug);

    const newsUrl = entityNewsUrl(slug);

    const [{ entity, entityLayoutFallback }, datacloudNews, news] =
      await Promise.all([
        entityLayoutData(slug, context),
        isSsr(context)
          ? baseFetcher(datacloudUrl, context)
              .then((data) => data)
              .catch(() => [])
          : Promise.resolve([]),
        isSsr(context)
          ? baseFetcher(newsUrl, context)
              .then((data) => data)
              .catch(() => [])
          : Promise.resolve([]),
      ]);

    if (!entity || entity.errors?.length) return { notFound: true };

    return {
      props: {
        slug,
        fallback: {
          ...entityLayoutFallback,
          [datacloudUrl]: datacloudNews,
          [newsUrl]: news,
        },
      },
    };
  } catch (error: any) {
    console.error("[slug].tsx ~ getServerSideProps ~ error", error);
    Bugsnag.notify(error);
    return { notFound: true };
  }
}

EntityNewsTabPage.getLayout = (page, { pageProps }) => {
  const { fallback } = pageProps;

  return (
    <SWRConfig value={{ fallback }}>
      <EntityPageContainer {...pageProps}>{page}</EntityPageContainer>
    </SWRConfig>
  );
};

export default EntityNewsTabPage;
